import country2 from "../../assets/images/language/chinese.png";
import country3 from "../../assets/images/language/european.png";
import country4 from "../../assets/images/language/indian.png";
import country5 from "../../assets/images/language/japanese.png";
import country6 from "../../assets/images/language/russian.png";

import client1 from "../../assets/images/client/01.jpg";
import client2 from "../../assets/images/client/02.jpg";
import client3 from "../../assets/images/client/03.jpg";
import client4 from "../../assets/images/client/04.jpg";
import client5 from "../../assets/images/client/05.jpg";
import client6 from "../../assets/images/client/06.jpg";
import client7 from "../../assets/images/client/07.jpg";
import client8 from "../../assets/images/client/08.jpg";
import client9 from "../../assets/images/client/09.jpg";
import client10 from "../../assets/images/client/10.jpg";

import doctor1 from "../../assets/images/doctors/01.jpg";
import doctor2 from "../../assets/images/doctors/02.jpg";
import doctor3 from "../../assets/images/doctors/03.jpg";
import doctor4 from "../../assets/images/doctors/04.jpg";
import doctor5 from "../../assets/images/doctors/05.jpg";
import doctor6 from "../../assets/images/doctors/06.jpg";
import doctor7 from "../../assets/images/doctors/07.jpg";
import doctor8 from "../../assets/images/doctors/08.jpg";
import doctor9 from "../../assets/images/doctors/09.jpg";
import doctor10 from "../../assets/images/doctors/10.jpg";

export const countryData = [
  {
    image: country2,
    name: "Chinese",
  },
  {
    image: country3,
    name: "European",
  },
  {
    image: country4,
    name: "Indian",
  },
  {
    image: country5,
    name: "Japanese",
  },
  {
    image: country6,
    name: "Russian",
  },
];

export const patientData = [
  {
    id: "1",
    image: client1,
    name: "Howard Tanner",
    age: "25",
    gender: "Male",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Cardiology",
    date: "13th Sep 2023",
    time: "11:00AM",
    status: "Approved",
  },
  {
    id: "2",
    image: client2,
    name: "Wendy Filson",
    age: "28",
    gender: "Female",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Gynecology",
    date: "29th Nov 2023",
    time: "11:00AM",
    status: "Pending",
  },
  {
    id: "3",
    image: client3,
    name: "Faye Bridger",
    age: "28",
    gender: "Female",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Psychotherapy",
    date: "29th Dec 2023",
    time: "3:00PM",
    status: "Approved",
  },
  {
    id: "4",
    image: client4,
    name: "Ronald Curtis",
    age: "25",
    gender: "Male",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Orthopedic",
    date: "13th March 2023",
    time: "1:00PM",
    status: "Approved",
  },
  {
    id: "5",
    image: client5,
    name: "Melissa Hibner",
    age: "28",
    gender: "Female",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Dental",
    date: "5th May 2023",
    time: "10:00AM",
    status: "Pending",
  },
  {
    id: "6",
    image: client6,
    name: "Randall Case",
    age: "25",
    gender: "Male",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Orthopedic",
    date: "19th June 2023",
    time: "09:00AM",
    status: "Approved",
  },
  {
    id: "7",
    image: client7,
    name: "Jerry Morena",
    age: "25",
    gender: "Male",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Dentist",
    date: "20th June 2023",
    time: "02:00PM",
    status: "Pending",
  },
  {
    id: "8",
    image: client8,
    name: "Lester McNally",
    age: "25",
    gender: "Male",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Gastrology",
    date: "31st Aug 2023",
    time: "01:30PM",
    status: "Approved",
  },
  {
    id: "9",
    image: client9,
    name: "Christopher Burrell",
    age: "28",
    gender: "Female",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Urology",
    date: "1st Sep 2023",
    time: "2:00PM",
    status: "Approved",
  },
  {
    id: "10",
    image: client10,
    name: "Mary Skeens",
    age: "28",
    gender: "Female",
    address: "1451 - ABC Street, NY",
    mobileNo: "(+452) 8945 4568",
    Department: "Neurology",
    date: "13th Sep 2023",
    time: "11:00AM",
    status: "Pending",
  },
];

export const doctorData = [
  {
    id: 1,
    image: doctor1,
    name: "Dr. Calvin Carlo",
    title: "Eye Care",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 2,
    image: doctor2,
    name: "Dr. Cristino Murphy",
    title: "Gynecology",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "5 Years Experienced",
  },
  {
    id: 3,
    image: doctor3,
    name: "Dr. Alia Reddy",
    title: "Psychotherapy",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "4 Years Experienced",
  },
  {
    id: 4,
    image: doctor4,
    name: "Dr. Toni Kovar",
    title: "Orthopedic",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "6 Years Experienced",
  },
  {
    id: 5,
    image: doctor5,
    name: "Dr. Jessica McFarlane",
    title: "Dentist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 6,
    image: doctor6,
    name: "Dr. Elsie Sherman",
    title: "Gastrologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 7,
    image: doctor7,
    name: "Dr. Bertha Magers",
    title: "Urologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 8,
    image: doctor8,
    name: "Dr. Louis Batey",
    title: "Neurologist",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 9,
    image: doctor9,
    name: "Dr. Julie Rosario",
    title: "Psychotherapy",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
  {
    id: 10,
    image: doctor10,
    name: "Dr. Scott Guzman",
    title: "Nutritionists",
    location: "63, PG Shustoke, UK",
    time: "Mon: 2:00PM - 6:00PM",
    fees: "$ 75 USD / Visit",
    exp: "3 Years Experienced",
  },
];

export const maritalStatuses = [
  {
    id: "CASADO_A",
    name: "CASADO/A",
  },
  {
    id: "SOLTERO_A",
    name: "SOLTERO/A",
  },
  {
    id: "VIUDO_A",
    name: "VIUDO/A",
  },
  {
    id: "OTRO",
    name: "OTRO",
  },
];

export const scheduleStatuses = [
  {
    id: "FREE",
    name: "Libre",
  },
  {
    id: "BUSY",
    name: "Ocupado",
  },
];

export const dataPatientSurgery = {
  series: [
    {
      name: "Camara hiperbarica",
      data: [100, 150, 125, 120, 200, 300, 250, 250, 200, 40, 20, 10],
    },
    {
      name: "Tatuajes sin dolor",
      data: [90, 140, 130, 120, 110, 120, 130, 140, 150, 160, 170, 180],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
    stacked: true,
    toolbar: {
      show: true,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 10,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
      dataLabels: {
        total: {
          enabled: true,
          style: {
            fontSize: "13px",
            fontWeight: 900,
          },
        },
      },
    },
  },
  //   enabled: false,
  //   offsetY: -40,
  //   style: {
  //     fontSize: "12px",
  //     // colors: ["#304758"],
  //   },
  // },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    convertedCatToNumeric: false,
  },
  legend: {
    position: "top",
  },
  fill: {
    opacity: 1,
  },
  colors: ["#53c797", "#4493f9"],
  // yaxis: {
  //   axisBorder: {
  //     show: true,
  //   },
  //   axisTicks: {
  //     show: true,
  //   },
  //   labels: {
  //     show: true,
  //   },
  // },
  title: {
    //text: "Procedimientos año 2024",
    // floating: true,
    // offsetY: 30,
    align: "center",
    style: {
      color: "#444",
    },
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
};

export const dataUsers = {
  series: [44, 30, 10],
  chart: {
    width: 380,
    type: "pie",
  },
  labels: ["Pacientes", "Médicos", "Secretarios"],
  legend: {
    position: "top",
  },
  colors: ["#53c797", "#4493f9", "#f1b561"],
};

export const dataProcedures = {
  series: [
    {
      name: "Camara hiperbarica 1 disponible",
      group: "Camara 1",
      data: [48, 50, 40, 20, 15],
    },
    {
      name: "Camara hiperbarica 2 disponible",
      group: "Camara 2",
      data: [44, 55, 41, 10, 11],
    },
    {
      name: "Camara hiperbarica 3 disponible",
      group: "Camara 3",
      data: [44, 55, 41, 35, 12],
    },
    {
      name: "Camara hiperbarica 1 agendado",
      group: "Camara 1",
      data: [20, 40, 25, 32, 34],
    },
    {
      name: "Camara hiperbarica 2 agendado",
      group: "Camara 2",
      data: [13, 36, 20, 28, 23],
    },
    {
      name: "Camara hiperbarica 3 agendado",
      group: "Camara 3",
      data: [13, 36, 20, 21, 32],
    },
  ],
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
  },
  stroke: {
    width: 1,
    colors: ["#fff"],
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  xaxis: {
    categories: ["ene", "feb", "mar", "abr", "may"],
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
    // horizontalAlign: 'left'
  },
  // colors: ["#80c7fd", "#008FFB", "#80f1cb", "#00E396"],
  colors: ["#53c797", "#53c797", "#53c797", "#4493f9", "#4493f9", "#4493f9"],
  // colors: ["#80c7fd", "#008FFB", "#008FFB", "#80c7fd", "#80c7fd", "#008FFB"],
};

export const dataProceduresPercentage = {
  series: [
    {
      name: "Disponibles",
      data: [44, 55, 41, 67, 22, 43, 21, 49, 22, 23, 0, 25],
    },
    {
      name: "Agendados",
      data: [13, 23, 20, 8, 13, 27, 33, 12, 26, 27, 20, 12],
    },
  ],
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    stackType: "100%",
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
  },
  colors: ["#53c797", "#4493f9"],
};

export const dataValorationsPercentage = {
  series: [
    {
      name: "Disponibles",
      data: [4, 5, 4, 7, 2, 3, 2, 4, 2, 3, 1, 5],
    },
    {
      name: "Agendados",
      data: [1, 2, 2, 8, 3, 7, 3, 1, 2, 2, 1, 2],
    },
  ],
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    stackType: "100%",
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
  },
  colors: ["#53c797", "#4493f9"],
};

export const dataAverage = {
  series: [
    {
      name: "Promedio eventos",
      data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
    formatter: function (val) {
      return val + "%";
    },
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
    labels: {
      show: true,
      formatter: function (val) {
        return val + "%";
      },
    },
  },
  /* title: {
    text: "Promedio año 2024",
    // floating: true,
    // offsetY: 30,
    align: "center",
    style: {
      color: "#444",
    },
  },*/
  colors: ["#4493f9"],
};

export const dataNumberPatientsRewind = {
  series: [
    {
      name: "Reagendamientos",
      data: [200, 300, 400, 500, 450, 400, 350, 300, 250, 200, 150, 100],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  /* title: {
    text: "Número de recompras mensuales",
    align: "center",
  },*/
  colors: ["#53c797"],
};

export const dataNumberPatientsCancelProcedures = {
  series: [
    {
      name: "Cancelados",
      data: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#f0735a"],
};

export const dataNumberPatientsCancelValorations = {
  series: [
    {
      name: "Cancelados",
      data: [14, 1, 2, 13, 24, 15, 26, 37, 28, 39, 20, 21],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  /*title: {
    text: "Número de cancelaciones de valoraciones mensuales",
    align: "center",
  },*/
  colors: ["#f0735a"],
};

export const dataNumberPatientsInto = {
  series: [
    {
      name: "Gosafe",
      data: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
    },
    {
      name: "Tradicional",
      data: [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#53c797", "#4493f9"],
};

export const dataSessionhyperbaricChamber = {
  series: [
    {
      name: "Sesiones",
      data: [10, 21, 22, 30, 44, 45, 56, 67, 78, 19, 20, 21],
    },
  ],
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#4493f9"],
};

export const optionsGroupedBySurgeryRoomsNox = {
  chart: {
    height: 350,
    type: "bar",
    stacked: true,
    toolbar: {
      show: true,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 10,
      borderRadiusApplication: "end",
      borderRadiusWhenStacked: "last",
      dataLabels: {
        total: {
          enabled: true,
          style: {
            fontSize: "13px",
            fontWeight: 900,
          },
        },
      },
    },
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top",
    },
    colors: ["#53c797", "#4493f9"],
  },
  legend: {
    position: "top",
  },
  fill: {
    opacity: 1,
  },
  colors: ["#53c797", "#4493f9"],
  title: {
    align: "center",
    style: {
      color: "#444",
    },
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
};

export const optionsEventsByAvailabilityProcedures = {
  chart: {
    type: "bar",
    height: 350,
    stacked: true,
    stackType: "100%",
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        legend: {
          position: "bottom",
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
  },
  colors: ["#53c797", "#4493f9"],
};

export const optionsAverageSchedulingCompletion = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
    formatter: function (val) {
      return val + "%";
    },
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
    labels: {
      show: true,
      formatter: function (val) {
        return val + "%";
      },
    },
  },
  colors: ["#4493f9"],
};

export const optionsPatientRepeatRegistrations = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#53c797"],
};

export const optionsProcedureCancellations = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#f0735a"],
};

export const optionsHyperbaricChamberSessions = {
  chart: {
    height: 350,
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  colors: ["#4493f9"],
};

export const optionsPatientSurgeryByTrack = {
  chart: {
    type: "bar",
    height: 350,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      borderRadiusApplication: "end",
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
    labels: {
      style: {
        fontSize: "8px",
        fontWeight: 500,
      },
    },
  },
  yaxis: {
    axisBorder: {
      show: true,
    },
    axisTicks: {
      show: true,
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + " pacientes";
      },
    },
  },
  colors: ["#53c797", "#4493f9"],
};

export const paginationOptions = [
  {
    id: "1",
    description: "1",
  },
  {
    id: "5",
    description: "5",
  },
  {
    id: "10",
    description: "10",
  },
  {
    id: "15",
    description: "15",
  },
  {
    id: "20",
    description: "20",
  },
];
export const SHIFT_TYPES = [
  { id: "SIX_HOURS_DAY", label: "6 Horas mañana" },
  { id: "SIX_HOURS_EVENING", label: "6 Horas tarde" },
  { id: "TWELVE_HOURS_NIGHT", label: "12 Horas noche" },
  { id: "TWELVE_HOURS_MORNING", label: "12 Horas día" },
  { id: "TWENTY_FOUR_HOURS", label: "24 Horas" },
];

export const translationShiftTypes = {
  SIX_HOURS_DAY: "6 Horas mañana",
  SIX_HOURS_EVENING: "6 Horas tarde",
  TWELVE_HOURS_MORNING: "12 Horas día",
  TWELVE_HOURS_NIGHT: "12 Horas noche",
  TWENTY_FOUR_HOURS: "24 Horas",
};

export const PROCEDURE_TYPES = [
  { id: "SCHEDULED", label: "Cirugía Programada" },
  { id: "URGENCY", label: "Urgencias" },
  { id: "EPIDURAL", label: "Epidural" },
  { id: "INTERSONCULTATION", label: "Interconsulta" },
];

export const translationProcedureTypes = {
  SCHEDULED: "Cirugía Programada",
  URGENCY: "Urgencias",
  EPIDURAL: "Epidural",
  INTERSONCULTATION: "Interconsulta",
};

export const ANESTESIA_TECHNIQUE = [
  { id: "SPINAL_ANESTHESIA", label: "Anestesia espinal" },
  { id: "ASSISTED_LOCAL", label: "Anestesia local asistida" },
  { id: "GENERAL_ANESTHESIA", label: "Anestesia general" },
  { id: "LOCAL_ANESTESIA", label: "Anestesia local" },
  { id: "PERIPHERAL_NERVE_BLOCK", label: "Bloqueo nervio periférico" },
  { id: "EPIRURAL_ANESTHESIA", label: "Anestesia epidural" },
  { id: "SEDATION", label: "Sedación" },
];

export const translationAnesthesiaTechniques = {
  SPINAL_ANESTHESIA: "Anestesia espinal",
  ASSISTED_LOCAL: "Anestesia local asistida",
  GENERAL_ANESTHESIA: "Anestesia general",
  LOCAL_ANESTESIA: "Anestesia local",
  PERIPHERAL_NERVE_BLOCK: "Bloqueo nervio periférico",
  EPIRURAL_ANESTHESIA: "Anestesia epidural",
  SEDATION: "Sedación",
};

export const CLEARANCE_STATUSES = [
  { id: "YES", label: "Sí" },
  { id: "NO", label: "No" },
  { id: "NO_BUT_CAN_RESCHEDULE", label: "No, pero puede reagendar" },
];

export const translationClearanceStatuses = {
  YES: "Sí",
  NO: "No",
  NO_BUT_CAN_RESCHEDULE: "No, pero puede reagendar",
};

export const patientFormFieldsByIpsId = {
  "8d47ae32-912a-476f-929a-9d0d73ed3b9c": {
    fields: {
      firstName: "",
      lastName: "",
      documentTypeId: "",
      document: "",
      birthCity: "",
      address: "",
      countryPhoneId: "",
      phoneNumber: "",
      email: "",
      ipsId: "",
    },
    validations: {
      firstName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los nombres no pueden ser vacios",
      ],
      lastName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los apellidos no pueden ser vacios",
      ],
      documentTypeId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un tipo de documento",
      ],
      document: [
        (val) => (val ?? "").toString().trim().length > 4,
        "El documento debe ser mayor a 4 caracteres",
      ],
      birthCity: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La ciudad no puede ser vacia",
      ],
      address: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La dirección no puede ser vacia",
      ],
      countryPhoneId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un pais del celular",
      ],
      phoneNumber: [
        (val) => (val ?? "").toString().trim().length > 9,
        "El numero de celular debe contener más de 9 digitos",
      ],
      email: [
        (value) => !value || value.includes("@"),
        "El email debe contener una @",
      ],
      ipsId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una ips",
      ],
    },
  },
  "b4590a74-489f-4ceb-a264-7c4f04228af5": {
    fields: {
      firstName: "",
      lastName: "",
      documentTypeId: "",
      document: "",
      genderId: "",
      birthDate: "",
      ratePlanId: "",
      ethnicityId: "",
      maritalStatus: "",
      department: "",
      city: "",
      address: "",
      countryPhoneId: "",
      phoneNumber: "",
      email: "",
      ipsId: "",
    },
    validations: {
      firstName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los nombres no pueden ser vacios",
      ],
      lastName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los apellidos no pueden ser vacios",
      ],
      documentTypeId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un tipo de documento",
      ],
      document: [
        (val) => (val ?? "").toString().trim().length > 4,
        "El documento debe ser mayor a 4 caracteres",
      ],
      genderId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un género",
      ],
      birthDate: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La fecha de nacimiento no puede ser vacia",
      ],
      ratePlanId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un plan de tarifa",
      ],
      ethnicityId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una etnia",
      ],
      maritalStatus: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un estado civil",
      ],
      department: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El departamento no puede ser vacio",
      ],
      city: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La ciudad no puede ser vacia",
      ],
      address: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La dirección no puede ser vacia",
      ],
      countryPhoneId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un pais del celular",
      ],
      phoneNumber: [
        (val) => (val ?? "").toString().trim().length > 9,
        "El numero de celular debe contener más de 9 digitos",
      ],
      email: [
        (value) => !value || value.includes("@"),
        "El email debe contener una @",
      ],
      ipsId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una ips",
      ],
    },
  },
  default: {
    fields: {
      firstName: "",
      lastName: "",
      documentTypeId: "",
      document: "",
      genderId: "",
      birthDate: "",
      ratePlanId: "",
      ethnicityId: "",
      maritalStatus: "",
      country: "",
      department: "",
      city: "",
      address: "",
      birthCountry: "",
      birthDepartment: "",
      birthCity: "",
      countryPhoneId: "",
      phoneNumber: "",
      email: "",
      ipsId: "",
    },
    validations: {
      firstName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los nombres no pueden ser vacios",
      ],
      lastName: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Los apellidos no pueden ser vacios",
      ],
      documentTypeId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un tipo de documento",
      ],
      document: [
        (val) => (val ?? "").toString().trim().length > 4,
        "El documento debe ser mayor a 4 caracteres",
      ],
      genderId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un género",
      ],
      birthDate: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La fecha de nacimiento no puede ser vacia",
      ],
      ratePlanId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un plan de tarifa",
      ],
      ethnicityId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una etnia",
      ],
      maritalStatus: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un estado civil",
      ],
      country: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El país no puede ser vacio",
      ],
      department: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El departamento no puede ser vacio",
      ],
      city: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La ciudad no puede ser vacia",
      ],
      address: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La dirección no puede ser vacia",
      ],
      birthCountry: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El país no puede ser vacio",
      ],
      birthDepartment: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El departamento no puede ser vacio",
      ],
      birthCity: [
        (val) => (val ?? "").toString().trim().length > 0,
        "La ciudad no puede ser vacia",
      ],
      countryPhoneId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un pais del celular",
      ],
      phoneNumber: [
        (val) => (val ?? "").toString().trim().length > 9,
        "El numero de celular debe contener más de 9 digitos",
      ],
      email: [
        (value) => !value || value.includes("@"),
        "El email debe contener una @",
      ],
      ipsId: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una ips",
      ],
    },
  },
};

export const isnotDefaultIps = [
  "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
  "b4590a74-489f-4ceb-a264-7c4f04228af5",
];

export const patientFormFieldsByIpsIdV2 = {
  firstName: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "Los nombres no pueden ser vacios",
    ],
    type: "text",
    label: "Nombres",
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  lastName: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "Los apellidos no pueden ser vacios",
    ],
    type: "text",
    label: "Apellidos",
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  documentTypeId: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "Selecciona un tipo de documento",
    ],
    type: "select",
    label: "Tipo de documento",
    option: [],
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  document: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 4,
      "El documento debe ser mayor a 4 caracteres",
    ],
    type: "text",
    label: "Número de documento",
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  genderId: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "Selecciona un género",
    ],
    type: "select",
    label: "Género",
    option: [],
    ipsIds: ["b4590a74-489f-4ceb-a264-7c4f04228af5", "default"],
  },
  birthDate: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "La fecha de nacimiento no puede ser vacia",
    ],
    type: "date",
    label: "Fecha de nacimiento",
    ipsIds: ["b4590a74-489f-4ceb-a264-7c4f04228af5", "default"],
  },
  patient: {
    ethnicityId: {
      value: "",
      validation: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona una etnia",
      ],
      type: "select",
      label: "Etnia",
      option: [],
      ipsIds: ["b4590a74-489f-4ceb-a264-7c4f04228af5", "default"],
    },
    maritalStatus: {
      value: "",
      validation: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un estado civil",
      ],
      type: "select",
      label: "Estado civil",
      ipsIds: ["b4590a74-489f-4ceb-a264-7c4f04228af5", "default"],
      option: maritalStatuses,
    },
    country: {
      value: "",
      validation: [
        (val) => (val ?? "").toString().trim().length > 0,
        "El país no puede ser vacio",
      ],
      type: "text",
      label: "País",
      ipsIds: ["default"],
      option: [],
    },
    department: {
      value: "",
      validation: [
        (val) => (val ?? "").toString().trim().length > 0,
        "Selecciona un departamento",
      ],
      type: "text",
      label: "Departamento",
      ipsIds: ["default"],
      option: [],
    },
  },
  city: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "La ciudad no puede ser vacia",
    ],
    type: "text",
    label: "Ciudad",
    ipsIds: ["default"],
    option: [],
  },
  address: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "La dirección no puede ser vacia",
    ],
    type: "text",
    label: "Dirección",
    ipsIds: ["default", "8d47ae32-912a-476f-929a-9d0d73ed3b9c"],
    option: [],
  },
  birthCountry: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "El país no puede ser vacio",
    ],
    type: "text",
    label: "País de nacimiento",
    ipsIds: ["default"],
    option: [],
  },
  birthDepartment: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "El departamento no puede ser vacio",
    ],
    type: "text",
    label: "Departamento de nacimiento",
    ipsIds: ["default"],
    option: [],
  },
  birthCity: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "La ciudad no puede ser vacia",
    ],
    type: "text",
    label: "Ciudad de nacimiento",
    ipsIds: ["default", "8d47ae32-912a-476f-929a-9d0d73ed3b9c"],
    option: [],
  },
  countryPhonesId: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 0,
      "Selecciona un pais del celular",
    ],
    type: "select",
    label: "País del celular",
    option: [],
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  phoneNumber: {
    value: "",
    validation: [
      (val) => (val ?? "").toString().trim().length > 9,
      "El numero de celular debe contener más de 9 digitos",
    ],
    type: "text",
    label: "Número de celular",
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
  email: {
    value: "",
    validation: [
      (value) => !value || value.includes("@"),
      "El email debe contener una @",
    ],
    type: "text",
    label: "Email",
    ipsIds: [
      "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
      "b4590a74-489f-4ceb-a264-7c4f04228af5",
      "default",
    ],
  },
};
